/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Vehicle_Action_Archive_SuccessInputs */

const fr_vehicle_action_archive_success = /** @type {(inputs: Vehicle_Action_Archive_SuccessInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ce véhicule a été archivé avec succès.`)
};

const en_vehicle_action_archive_success = /** @type {(inputs: Vehicle_Action_Archive_SuccessInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`This vehicle was archived successfully.`)
};

/**
* | output |
* | --- |
* | "This vehicle was archived successfully." |
*
* @param {Vehicle_Action_Archive_SuccessInputs} inputs
* @param {{ locale?: "fr" | "en" }} options
* @returns {LocalizedString}
*/
export const vehicle_action_archive_success = /** @type {((inputs?: Vehicle_Action_Archive_SuccessInputs, options?: { locale?: "fr" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Vehicle_Action_Archive_SuccessInputs, { locale?: "fr" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_vehicle_action_archive_success(inputs)
	return en_vehicle_action_archive_success(inputs)
});